// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"263":"recipes","270":"cms","445":"start","644":"account","945":"dashboard"}[chunkId] || chunkId) + "." + {"263":"a9528f2b","270":"cf91b9d9","438":"605db2b1","445":"9a5639b1","574":"3f0c4407","644":"648869bf","945":"d8a342cb"}[chunkId] + ".css";
};